import { render, staticRenderFns } from "./FRadioButton.vue?vue&type=template&id=860b5590&"
import script from "./FRadioButton.vue?vue&type=script&lang=js&"
export * from "./FRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports